module.exports = __webpack_public_path__ + "c5732fdb6a6bd06f59c112736603f8b1.glb";